import styled from 'styled-components';
import { Button, Icon } from 'view/atoms';
import { Media } from 'enums';

export const CustomFavoriteIcon = styled(Icon)`
  @media ${Media.mobile} {
    width: 20px;
    height: 20px;
  }
`;

export const FavoriteButtonStyle = styled(Button)`
  @media ${Media.mobile} {
    width: 40px;
    height: 40px;
  }

  padding: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 100px;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 1;
  }
`;
